export default __webpack_public_path__ + "static/media/logo.2c98e9e7.png";